import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-notice',
  templateUrl: './error-notice.component.html',
  styleUrls: ['./error-notice.component.scss'],
})
export class ErrorNoticeComponent {
  @Input() header: string = '';
  @Input() text: string = '';
}
